import { render, staticRenderFns } from "./TgUrlCopy.vue?vue&type=template&id=f60a5bba"
import script from "./TgUrlCopy.vue?vue&type=script&lang=js"
export * from "./TgUrlCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports